import { Tabs } from '@data-products-and-ai/react-components';
import React, { useEffect, useState } from 'react';
import {
  Route,
  Routes,
  useNavigate,
  Navigate,
  useLocation,
} from 'react-router-dom';
import NotFoundPage from '../NotFound/NotFoundPage';

import SparePartsSelector from '@/shared/components/SparePartsSelector';

const HomePage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const tabs = [ 'parts-sales', 'spare-parts-selector'];
  const [selectedTab, setSelectedTab] = useState(tabs[0]);

  useEffect(() => {
    const path = location.pathname.slice(1);
    if (tabs.includes(path)) {
      setSelectedTab(path);
    } else {
      setSelectedTab('spare-parts-selector');
    }
  }, []);

  return (
    <div className="homePage">
      <div className="homePage__grid">
        <div className="homePage__container">
          <div className="homePage__tabs">
            <Tabs
              fontSize={18}
              centered={false}
              selectedHasBold={true}
              hasBorder={true}
              selectedKey={selectedTab}
              onChange={(elem) => {
                navigate(elem);
              }}
              data={[
                {
                  key: 'spare-parts-selector',
                  label: 'Spare Parts Selector',
                },
              ]}
            />
          </div>
          <Routes>

            <Route path="/" element={<Navigate to="/spare-parts-selector" />} />
            <Route path="/spare-parts-selector" element={<SparePartsSelector />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
